import { TotalEarlySettlement } from 'cpnl-common';
import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { TotalEarlySettlementContentSelector } from './TotalEarlySettlementContentSelector';
import { fetchTotalEarlySettlement } from './TotalEarlySettlementContentSlice';

export function useTotalEarlySettlementCms(): AbstractContentState<TotalEarlySettlement> {
    return useCmsContent(fetchTotalEarlySettlement, TotalEarlySettlementContentSelector);
}
